import { render, staticRenderFns } from "./UniversesFilter.vue?vue&type=template&id=1aa0f6d2&scoped=true"
import script from "./UniversesFilter.vue?vue&type=script&lang=js"
export * from "./UniversesFilter.vue?vue&type=script&lang=js"
import style0 from "./UniversesFilter.vue?vue&type=style&index=0&id=1aa0f6d2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa0f6d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/_work/studio-admin/studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa0f6d2')) {
      api.createRecord('1aa0f6d2', component.options)
    } else {
      api.reload('1aa0f6d2', component.options)
    }
    module.hot.accept("./UniversesFilter.vue?vue&type=template&id=1aa0f6d2&scoped=true", function () {
      api.rerender('1aa0f6d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/filters/UniversesFilter.vue"
export default component.exports